import { useState } from "react";
import QRCode from "qrcode";
import { Box, Button } from "@mui/material";

import cashilogo from "../../assets/cashiblack.png";

export default function PrintReviewQr({ qrValue, store_name , store_image}) 
{
    const [open,   setOpen]   = useState(false);
    const [qrHtml, setQrHtml] = useState("");
    const [bgColor, setBgColor] = useState("#f87046");

    /* ---------- Convert image URL → Base64 ---------- */
    const imageToBase64 = (src) => 
    {
        return new Promise((resolve) => 
        {
            const img = new Image();

            img.onload = () => 
            {
                try 
                {
                  const canvas = document.createElement("canvas");
                  canvas.width = img.width;
                  canvas.height = img.height;

                  const ctx = canvas.getContext("2d");
                  ctx.drawImage(img, 0, 0);

                  resolve(canvas.toDataURL("image/png"));
                } 
                catch (e) {
                  console.error("Canvas error:", e);
                  resolve(src); // fallback to normal URL
                }
            };

            img.onerror = (e) => 
            {
                console.error("Image load failed:", src, e);
                resolve(src); // fallback to normal URL
            };
          img.src = src;
      });

    };

    const qrStyles = `<style>
          @page { margin:0; }
          .qr-wrapper { display:flex; justify-content:center; }
          .card { width:420px; padding:0px;  }
          .preview-scale { transform: scale(0.75); transform-origin: top center; }

          .bluecard { width:420px; height:720px; background: var(--qr-bg); border-radius:36px; padding:30px; box-sizing:border-box; color:#fff;
                      display:flex; flex-direction:column; align-items:center; }
          .store-logo {height:70px;margin-bottom:25px;}
          .desc { font-size:30px; text-align:center; margin:18px 0; }

          .qr-box img { width:220px; height:220px; }
          .cta { padding:16px 38px;border-radius:30px;font-size:24px;font-weight:800;margin-top:22px;}
          .footer {margin-top:auto;font-size:18px;color:#333;display:flex;gap:6px;align-items:center; background: #fff; padding: 0px 7px;}
          .footer img { height:20px; }
          @media print 
          {
            .preview-scale { transform: scale(1); }
          }
      </style>`;
  
    const buildQrHtml = ({ storeBase64, imgData, base64Logo,bgColor  }) => 
    {
      return `${qrStyles}
        <div class="qr-wrapper qr-print-area preview-scale">

          <div class="card ">
            <div class="bluecard" style="--qr-bg:${bgColor};">

              ${storeBase64 ? `<img src="${storeBase64}" class="store-logo" />` : ""}

              <svg width="360" height="60" viewBox="0 0 720 120">
                <g fill="#ffd700" stroke="#000" stroke-width="2">
                  <polygon points="60,10 74,48 115,48 82,70 96,108 60,84 24,108 38,70 5,48 46,48"/>
                  <polygon points="210,10 224,48 265,48 232,70 246,108 210,84 174,108 188,70 155,48 196,48"/>
                  <polygon points="360,10 374,48 415,48 382,70 396,108 360,84 324,108 338,70 305,48 346,48"/>
                  <polygon points="510,10 524,48 565,48 532,70 546,108 510,84 474,108 488,70 455,48 496,48"/>
                  <polygon points="660,10 674,48 715,48 682,70 696,108 660,84 624,108 638,70 605,48 646,48"/>
                </g>
              </svg>

              <div class="desc">Tell us what you think <br/> your review matters!</div>
              <div class="qr-box"><img src="${imgData}" /></div>
              <div class="cta">SCAN TO REVIEW</div>
              <div class="footer">Powered by <img src="${base64Logo}" /></div>

            </div>
          </div>

        </div>
      `;
    };

  /* ---------- Build QR + Open Modal ---------- */
  const handleGenerateQR = async () => 
  {
      if (!qrValue) return;

      const base64Logo = await imageToBase64(cashilogo);
      const storeBase64 = await imageToBase64(store_image);

      const canvas = document.createElement("canvas");
      await QRCode.toCanvas(canvas, String(qrValue), {width: 350,margin: 1,});

      const imgData = canvas.toDataURL("image/png");

      setQrHtml(buildQrHtml({storeBase64,imgData,base64Logo,bgColor}));

      setOpen(true);
  };

  /* ---------- Rebuild preview when color changes ---------- */
  const rebuildWithColor = () => 
  {
    if (!qrHtml) return;

    setQrHtml((prev) =>
      prev.replace(/--qr-bg:.*?;/, `--qr-bg:${bgColor};`)
    );
  };

  /* ---------- iframe print ---------- */
  const handlePrint = () => {
    const iframe = document.createElement("iframe");

    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`<html><head><title>Print QR</title></head><body>${qrHtml}</body></html>`);
    doc.close();

    iframe.onload = () => 
    {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {document.body.removeChild(iframe);}, 1000);
    };

  };

  return (
    <>
      {/* Button on page */}
      <Button variant="contained" onClick={handleGenerateQR} >Show QR</Button>

      {open && (
        <div className="modal-overlay">
          <div className="modal-container" style={{ maxWidth: "60%" }}>
            {/* Header */}
            <div className="headerStyles"><h6>{store_name} : Review QR</h6> <span className="closeButtonStyles" onClick={() => setOpen(false)}>✕</span></div>
            {/* Body */}
            
            <div className="modal-content">
              <div dangerouslySetInnerHTML={{ __html: qrHtml }} />

              <Box mt={3} display="flex" justifyContent="center" alignItems="center" gap={3}>
                  {/* Color Picker */}
                  <div>
                    <label style={{ fontSize: 14 }}>Background</label>
                    <input type="color" value={bgColor} onChange={(e) => { setBgColor(e.target.value); rebuildWithColor(); }}
                        style={{ marginLeft: 8, width: 45, height: 35, cursor: "pointer", }}/>
                  </div>

                  {/* Print Button */}
                  <Button variant="contained" size="large" onClick={handlePrint}>Print</Button>
              </Box>
              
            </div>

          </div>
        </div>
      )}
    </>
  );
}
